import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../data/mock';
import SectionHeading from './SectionHeading';

const FAQ = () => {
  return (
    <section id="faqs" className="section-pad bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Common Questions"
          title="Frequently Asked"
          accent="Questions"
          subtitle="Everything you need to know before booking your custom coconut experience."
        />

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-pink-100 bg-white rounded-2xl px-5 shadow-soft data-[state=open]:bg-blush/40 data-[state=open]:border-pink-200"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display font-semibold text-stone-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 pb-5 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
